import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import SpinnerLoader from "components3/src/Common/Loaders/SpinnerLoader";
import Button from "components3/src/Button";
import FocusLock from "react-focus-lock";
import {
  Overlay,
  Wrapper,
  Header,
  Icon,
  HeadingWrapper,
  Heading,
  MessageWrapper,
  Message,
} from "./styled";

const OfflineOverlay = (props) => {
  const { intl } = props;
  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowBtn(!showBtn);
    }, 5000);
  }, []);

  return (
    <Overlay>
      <FocusLock>
        <Wrapper>
          <Header>
            <Icon className="fa-light fa-triangle-exclamation" />
            <HeadingWrapper>
              <Heading>
                {intl.formatMessage({ id: "OfflineOverlay.heading" })}
              </Heading>
            </HeadingWrapper>
          </Header>
          <MessageWrapper>
            <Message>
              {intl.formatMessage({ id: "OfflineOverlay.info" })}
            </Message>
            <Message>
              {intl.formatMessage({ id: "OfflineOverlay.tryingReconnect" })}
            </Message>
            <SpinnerLoader />
            {showBtn && (
              <Button
                extra={{ label: "OfflineOverlay.reload" }}
                onClick={() => window.location.reload()}
              />
            )}
          </MessageWrapper>
        </Wrapper>
      </FocusLock>
    </Overlay>
  );
};

export default injectIntl(OfflineOverlay);
